import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { GLOBAL } from 'src/app/app.globals';
import { FileUploadService } from './file-upload.service';
export class FileDoc {
  file: File | object;
  isUploaded ? = false;
  VerifyBy?: string ='';
  VerifyDate?: string | null;
  IsVerify ? = false;
  documentTypeCode?: number;
  url?: string;
  ID?: number;
}

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit, OnChanges {

  @Input() multiple = true;
  @Input() documentTypes;
  @Output() filesChanged: EventEmitter<FileDoc[]> = new EventEmitter();
  public hasBaseDropZoneOver = false;
  @Input() allowedFileTypes = GLOBAL.ALLOWED_FILE_TYPES;
  @Input() files: FileDoc[] = [];
  newFiles: File[] = [];
  // 5 mb is max size for file
  @Input() maxSizeAllowed: number = GLOBAL.ALLOWED_FILE_SIZE * 1024;
  invalidFileType: boolean;
  invalidFileTypeMessage = '';
  @Input() isContractor = false;
  @Input() disabled = false;

  constructor(
    public fileUploadService: FileUploadService
  ) { }

  ngOnInit() {
    this.checkAndAutoSelectDocumentType();
  }

  ngOnChanges() {
    this.checkAndAutoSelectDocumentType();
  }

  private checkAndAutoSelectDocumentType() {
    if (this.documentTypes && this.documentTypes.length === 1) {
      // Auto-select the single document type for all files that don't have a type selected
      this.files.forEach(file => {
        if (!file.documentTypeCode && !file.isUploaded) {
          file.documentTypeCode = this.documentTypes[0].DocumentType_Code;
        }
      });
      this.filesChanged.emit(this.files);
    }
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = true;
  }

  public fileOverAnother(e: any): void {
    this.hasBaseDropZoneOver = false;
  }
  
  canDelete(file: FileDoc): boolean {
    // Verified file → never delete
    if (file.IsVerify) return false;

    // Contractor can delete ONLY unsaved files
    if (this.isContractor) {
      return !file.isUploaded;
    }

    // Other users: cannot delete after verification
    return !(file.VerifyDate && file.VerifyBy);
  }

  updateFilesArray(newFiles) {
    Array.from(newFiles).forEach((file: File) => {
      const newFileDoc = {
        file,
        isUploaded: false,
        IsVerify: false,
        documentTypeCode: this.documentTypes && this.documentTypes.length === 1 ? this.documentTypes[0].DocumentType_Code : undefined
      };
      this.files.push(newFileDoc);
    });
    this.filesChanged.emit(this.files);
    this.fileUploadService.files = this.files;
  }

  fileUploadedFromInput(event) {
    this.invalidFileType = false;
    const newFiles = event.target.files;
    if (newFiles && newFiles.length > 0) {
      if (this.checkValidFileType(newFiles)) {
        this.updateFilesArray(newFiles);
      } else {
        this.invalidFileType = true;
      }
    }
  }

  checkValidFileType(files): boolean {
    const name = files[0].name;
    const fileExtension = name.split('.').length ? `.${name.split('.')[(name.split('.').length)-1]}` : '';
    if (!this.allowedFileTypes.includes(fileExtension)) {
      this.invalidFileTypeMessage = 'Only '+this.allowedFileTypes+' file are allowed.';
      return false;
    }
    if (!this.checkValidFileSize(files)) {
      this.invalidFileTypeMessage = 'Max file size allowed is 5MB.';
      return false;
    }

    return true;
  }

  checkValidFileSize(files): boolean {
    const size = files[0].size;
    return size / 1024 < this.maxSizeAllowed;
  }

  checkForAllowedFileTypes(newFiles) {
  }

  fileUploadedFromDrop(event) {
    // const newFiles = event.dataTransfer.files;
    // this.updateFilesArray(newFiles);
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.filesChanged.emit(this.files);
  }

  updateDocType() {
    this.filesChanged.emit(this.files);
  }

}
